/** Interfaces */
import { BydCurrentLanguageInterface } from '../interfaces/byd-current-language.interface';

export class BydCurrentLanguage {
  /**
   * Current connected user language.
   */
  public lang: string;

  /**
   * Creates an instance of BydCurrentLanguage.
   *
   * @param jsonData the json data
   */
  constructor(jsonData: BydCurrentLanguageInterface) {
    this.lang = jsonData.lang;
  }
}
